<template>
  <DialogBase ref="dialogBase" :title="$gt('Supportanfrage')" iconType="lifeBuoy" :onCancel="closeDialog" :onAction="submit" actionButtonText="Absenden">
    <template v-slot:content>
      <v-row>
        <v-col cols="12" sm="4" class="d-flex justify-center align-start">
          <v-img src="@/assets/images/image_support.jpg" max-width="140px" class="rounded-lg elevation-1" :alt="$gt('Ihr Ansprechpartner')"></v-img>
        </v-col>

        <v-col cols="12" sm="8">
          <div>
            <h3 class="contact-title">{{ $gt('Ihr Ansprechpartner') }}</h3>
            <p class="contact-name mb-1">{{ $gt('Lisa Müller') }}</p>
            <p class="contact-role mb-3">{{ $gt('Kundenservice & technischer Support') }}</p>

            <div class="d-flex align-center mb-1">
              <Clock class="mr-2 dialog-icon" />
              <span class="contact-text">{{ $gt('Mo–Fr: 8:00–17:00 Uhr') }}</span>
            </div>
            <div class="d-flex align-center mb-1">
              <Mail class="mr-2 dialog-icon" />
              <a href="mailto:support@kars-connection.de" class="custom-link">{{ $gt('support@kars-connection.de') }}</a>
            </div>
          </div>
        </v-col>
      </v-row>

      <v-divider class="mt-6 mb-8"></v-divider>

      <v-row>
        <v-col cols="12">
          <p class="mb-2">{{ $gt('Bitte geben Sie an, worum es sich bei Ihrer Anfrage handelt und beschreiben Sie Ihr Anliegen kurz.') }}</p>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <Select
            v-model="formModel.topic"
            :items="[
              'Frage zur Bedienung',
              'Fehler in der Anwendung',
              'Frage zum Fall',
              'Konto und Abonnement',
              'Allgemeine Frage',
              'Idee/Verbesserungsvorschlag',
            ]"
            :label="$gt('Thema der Anfrage')"
            variant="outlined"
            required
          />
        </v-col>

        <v-col cols="12">
          <Textarea v-model="formModel.message" :label="$gt('Ihre Nachricht')" variant="outlined" rows="5" required />
        </v-col>
      </v-row>

      <v-alert v-if="error" type="error" class="mt-4" rounded="lg">
        {{ errorMsg }}
      </v-alert>
    </template>
  </DialogBase>

  <Alert
    ref="confirmationAlert"
    :title="$gt('Anfrage gesendet')"
    content="Ihre Supportanfrage wurde erfolgreich übermittelt. Wir werden uns schnellstmöglich bei Ihnen melden."
    type="success"
  />
</template>

<script>
import DialogBase from "@/components/windows/dialogs/DialogBase.vue";
import Alert from "@/components/windows/msgBoxes/Alert.vue";
import Select from "@/components/inputs/select/Select.vue";
import Textarea from "@/components/inputs/TextArea.vue";

import { Mail, Clock } from "lucide-vue-next";
import cloneDeep from "lodash/cloneDeep";

const defaultFormModel = {
  topic: "",
  message: "",
};

export default {
  name: "DialogSupport",

  components: {
    DialogBase,
    Alert,
    Mail,
    Clock,
    Select,
    Textarea,
  },

  props: {
    open: {
      type: Boolean,
      default: false,
    },
  },

  emits: ["update:open"],

  data() {
    return {
      formModel: cloneDeep(defaultFormModel),
      error: false,
      errorMsg: "",
      loading: false,
    };
  },

  watch: {
    open(newVal) {
      if (newVal) {
        this.$refs.dialogBase.openDialog();
      } else {
        this.$refs.dialogBase.closeDialog();
      }
    },
  },

  methods: {
    openDialog() {
      this.formModel = { ...defaultFormModel };
      this.error = false;
      this.errorMsg = "";
      this.$refs.dialogBase.openDialog();
      this.$emit("update:open", true);
    },

    closeDialog() {
      this.$refs.dialogBase.closeDialog();
      this.$emit("update:open", false);
    },

    async submit() {
      const isValid = await this.$refs.dialogBase.validate();
      if (!isValid) {
        this.error = true;
        this.errorMsg = "Bitte prüfen Sie die rot umrandeten Felder und korrigieren Sie diese.";
        return;
      }

      this.closeDialog();
      this.$refs.confirmationAlert.openWindow();
    },
  },
};
</script>

<style scoped>
.contact-title {
  font-size: 0.9rem;
  font-weight: 600;
  color: var(--dark-color);
}

.contact-name {
  font-size: 1.05rem;
  font-weight: 600;
  color: var(--primary-color);
}

.contact-role {
  font-size: 0.85rem;
  color: var(--grey-color);
}

.contact-text {
  font-size: 0.9rem;
  color: var(--dark-color);
}

.dialog-icon {
  width: 18px;
  height: 18px;
  stroke-width: 1.5;
  color: var(--primary-color);
}

.custom-link {
  color: var(--primary-color);
  text-decoration: none;
}

.custom-link:hover {
  text-decoration: underline;
}
</style>
